import { inject, Injectable } from '@angular/core';
import { MingleService } from '@totvs/mingle';
import { Observable } from '@totvs/mingle/node_modules/rxjs';
import { environment } from 'src/environments/environment';

import { UserService } from '../user/user.service';
import { CryptoHeaderService } from './crypto-header.service';

const API_PORTAL = environment.url_portal;

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private mingleService = inject(MingleService);
  private userService = inject(UserService);
  private cryptoHeaderService = inject(CryptoHeaderService);

  private readonly APP_ID = '0033';

  post(
    endpoint: string,
    body?: any,
    params?: Record<string, any>,
    headers?: Record<string, any>,
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
  ) {
    const baseOptions = { params, headers, responseType, body };
    const finalOptions = this.prepareOptions(baseOptions);

    return this.mingleService.gateway.post(`${API_PORTAL}/${endpoint}`, finalOptions);
  }

  get(endpoint: string, options?: Object, queryParams?: Object): Observable<any> {
    const finalOptions = this.prepareOptions(options);

    return this.mingleService.gateway.get(`${API_PORTAL}/${endpoint}`, finalOptions, queryParams);
  }

  postPasswordRecovery(body: any) {
    return this.mingleService.auth.passwordRecovery(body);
  }

  private generateAuthHeaders(): Record<string, string> {
    const headers: Record<string, string> = {
      'x-totvs-app': this.APP_ID,
    };

    const loginData = this.userService.getLoginDetails();

    if (loginData) {
      const loginUserJson = JSON.stringify({
        login: loginData.username,
        code: loginData.code,
      });

      headers['x-totvsHealthPlans-loginUser'] = this.cryptoHeaderService.encrypt(loginUserJson);

      if (loginData.tenantId) {
        headers['tenantId'] = loginData.tenantId;
      }
    }

    return headers;
  }

  private prepareOptions(options: any = {}): any {
    const authHeaders = this.generateAuthHeaders();

    const mergedHeaders = {
      ...authHeaders,
      ...(options.headers || {}),
    };

    return {
      ...options,
      headers: mergedHeaders,
    };
  }
}
